import {InjectionToken} from '@angular/core';

export const userCfg = new InjectionToken('cfg');
